// extracted by mini-css-extract-plugin
export default {"form-drawer":"style_form-drawer__uYDXS__WHx6O"};